module.exports = __webpack_public_path__ + "img/logo.668f68e3.png";